import { Text } from '@/components/widgets/blog/BlogIntroduction.styles'

type BlogIntroductionProps = {
  text: string
}

const BlogIntroduction: React.FC<BlogIntroductionProps> = ({ text }) => {
  return <Text dangerouslySetInnerHTML={{ __html: text }}></Text>
}

export default BlogIntroduction
